import Flickity from 'flickity';

export default class ShowcaseList {
    constructor(container) {
        this.container = container;
        this.list = container.querySelector('.showcase-list-block__list');
        this.leftArrow = container.querySelector('.showcase-list-block__scroll-left');
        this.rightArrow = container.querySelector('.showcase-list-block__scroll-right');

        if (!this.list || !this.leftArrow || !this.rightArrow) return;

        this.initCarousel();
    }

    initCarousel() {
        if (this.container.getAttribute('data-carousel-loaded') === 'true') {
            return;
        }

        this.flickity = new Flickity(this.list, {
            contain: true,
            freeScroll: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            cellSelector: '.showcase-card'
        });

        this.container.setAttribute('data-carousel-loading', 'false');
        this.container.setAttribute('data-carousel-loaded', 'true');

        this.bindArrowEvents();
        this.updateArrowVisibility();
        this.updateAriaHidden();

        this.flickity.on('select', () => {
            this.updateArrowVisibility();
            this.updateAriaHidden();
        });
    }

    bindArrowEvents() {
        this.leftArrow.addEventListener('click', () => {
            this.flickity.previous();
        });

        this.rightArrow.addEventListener('click', () => {
            this.flickity.next();
        });
    }

    updateArrowVisibility() {
        const slideCount = this.flickity.slides.length;

        if (slideCount <= 1 || this.flickity.options.wrapAround) {
            this.leftArrow.classList.add('visible');
            this.rightArrow.classList.add('visible');
            return;
        }

        const isFirst = this.flickity.selectedIndex === 0;
        const isLast = this.flickity.selectedIndex === slideCount - 1;

        this.leftArrow.classList.toggle('visible', !isFirst);
        this.rightArrow.classList.toggle('visible', !isLast);
    }

    updateAriaHidden() {
        this.flickity.cells.forEach(cell => {
            const element = cell.element;
            if (!element) return;

            element.removeAttribute('aria-hidden');

            const focusables = element.querySelectorAll('a, button, input, select, textarea');
            focusables.forEach(el => el.removeAttribute('tabindex'));
        });
    }
}
